import React from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { HeadingBox, Logo } from "cakemail-ui-components/lib/react";
import { I18n } from "react-redux-i18n";
import { getReferalBadgeLink } from "utils/IsValidEmail";
import { LIMIT_FEATURE, limitsFeaturesAccess } from "utils/LimitsAndFeatures";

const ListUnsubscribe = (props) => {
	let title = I18n.t("app-lists-initial-redirection-unsubscription-title");
	let text = I18n.t("app-lists-initial-redirection-unsubscription-desc");

	if (props.listName) {
		text = I18n.t("app-lists-initial-redirection-unsubscription-desc-name");
	}

	if (props.fromAll) {
		text = I18n.t("app-lists-initial-redirection-unsubscriptionAll-desc-name");
	}

	let logoLink = getReferalBadgeLink(
		props.campaignId,
		"campaign",
		"unsubscribe"
	);
	const removeLogo = limitsFeaturesAccess(
		LIMIT_FEATURE.INSERT_RESELLER_LOGO,
		props.publicUserBrand?.config?.usage_limits
	);

	return (
		<div className="optOut">
			{props.goodImg && (
				<img
					className="accountLogo"
					src={props.imgUrl}
					{...props.imgExtraAttr}
				/>
			)}
			<HeadingBox title={title} text={text} />

			{props.listName && (
				<div className="listNameContainer">
					<p>{props.listName}</p>
				</div>
			)}

			{!removeLogo && (
				<a href={logoLink}>
					<Logo url={props.logo} alt={props.resellerName} />
				</a>
			)}
		</div>
	);
};

ListUnsubscribe.propTypes = {
	logo: PropTypes.string,
	resellerName: PropTypes.string,
	history: PropTypes.object,
	goodImg: PropTypes.bool,
	imgUrl: PropTypes.string,
	imgExtraAttr: PropTypes.object,
	listName: PropTypes.string,
	addUtm: PropTypes.func,
	formId: PropTypes.string,
	listId: PropTypes.string,
	campaignId: PropTypes.string,
	publicUserBrand: PropTypes.object,
	fromAll: PropTypes.bool,
};

export default withRouter(ListUnsubscribe);
